// client/src/features/admin/routes.js
export default [
  {
    path: "/admin/",
    name: "admin",
    component: () => import("@/features/admin/pages/AdminPanelPage.vue"),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      layout: "app",
      group: "Admin",
      title: "Admin",
      breadcrumbs: [{ name: "Admin", route: "admin" }],
    },
  },
  {
    path: "/admin-panel/",
    name: "admin-panel",
    redirect: () => ({ name: "admin" }),
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
      layout: "app",
      group: "Admin",
      title: "Admin",
      breadcrumbs: [{ name: "Admin", route: "admin" }],
    },
  },
];